module.exports = __webpack_public_path__ + "static/media/BadgeTemplates-25.9a193d3a.svg";